module.exports = __webpack_public_path__ + "img/512x512.bee3bdf1.png";